<template>
    <ModalComponent name="pagarPlazos" @close="close">
        <div v-if="!compraConfirmada">
            <FormTerminos
                :pago_plazos="true"
                :condiciones_plazos="footer.condiciones_abonos_plazos"
                @continuar="aceptarCondiciones"
            />
            <button
                @click="continuarCompra" name="button"
                :class="terminosContinuar ? 'button effect-button large-button' : 'button effect-button large-button disabled'"
                :disabled="!terminosContinuar">
                <span>{{ $t('perfil.continuar') }}</span>
            </button>
        </div>
        <div class="accordion" v-else>
            <div class="col-12" v-if="error">
                <div class="alert alert-danger" role="alert">
                    {{ $t('perfil.error') }}
                </div>
            </div>
            <b-form-radio-group v-if="!loading" v-model="selected">
                <b-card v-if="infoRecuperada" no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1" role="tab">
                        <div class="d-flex flex-row justify-content-between align-items-end px-2 pt-1"
                            @click="nuevaTarjeta = false; tarjetaGuardada = true">
                            <b-form-radio :value="tarjetaGuardada" style="pointer-events: none;">
                                <p>{{ $t('perfil.tarjeta_guardada') }}</p>
                            </b-form-radio>
                            <div class="d-flex align-items-center">
                                <h3 class="mr-2"><i :class="tipoTarjeta"></i></h3>
                                <small>{{ $t('perfil.tarjeta_termina_en', { tarjetaFormatted: tarjetaFormatted }) }}</small>
                            </div>
                        </div>
                    </b-card-header>
                    <b-collapse v-model="tarjetaGuardada" accordion="my-accordion" role="tabpanel">
                        <b-card-body class="d-flex">
                            <button @click="procesarPagoPlazosPerfil" class="button effect-button large-button ml-auto"
                                :disabled="!terminosContinuar">
                                <span>{{ $t('perfil.realizar_pago') }}</span>
                            </button>
                        </b-card-body>
                    </b-collapse>
                </b-card>
                <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1" role="tab">
                        <div class="d-flex align-items-center p-2" @click="nuevaTarjeta = true; tarjetaGuardada = false">
                            <b-form-radio :value="nuevaTarjeta" style="pointer-events: none;">
                                {{ $t('perfil.nueva_info_pago') }}
                            </b-form-radio>
                        </div>
                    </b-card-header>
                    <b-collapse id="formularioPago" v-model="nuevaTarjeta" accordion="my-accordion" role="tabpanel">
                        <b-card-body class="d-flex flex-column">
                            <PagoPaycometComponent
                                :tipo_venta="tipo_venta"
                                :plazos="plazos"
                                :jet_id="jet_id"
                                :tid="tid"
                                :guardarTarjeta="guardarTarjeta" 
                                @confirmacionTarjeta="close(true)"
                            />
                            <b-form-checkbox class="ml-auto" v-model="guardarTarjeta">
                                <small>{{ $t('perfil.guardar_tarjeta') }}</small>
                            </b-form-checkbox>
                        </b-card-body>
                    </b-collapse>
                </b-card>
            </b-form-radio-group>
            <div style="padding: 50px;" v-else>
                <LoaderComponent></LoaderComponent>
            </div>
        </div>
    </ModalComponent>
</template>

<script>
import ModalComponent from '@/components/backend/components/ModalComponent';
import PagoPaycometComponent from "@/components/frontend/compra/components/PagoPaycometComponent";
import FormTerminos from '@/components/frontend/components/FormTerminos';

export default {
    props: ['plazos', 'tipo_venta'],
    data() {
        return {
            editInfoPago: false,
            jet_id: null,
            loading: false,
            terminos: false,
            privacidad: false,
            condiciones: false,
            comunicaciones: false,
            compraConfirmada: false,
            nuevaTarjeta: false,
            tarjetaGuardada: false,
            selected: true,
            cardNumber: null,
            cardMonth: null,
            cardYear: null,
            guardarTarjeta: false,
            error: false,
            infoRecuperada: false
        }
    },
    computed: {
        footer() {
            return this.$store.getters.getFooter
        },
        tid() {
            const teatro = this.$store.getters.getTeatro;
            return teatro.hash;
        },
        terminosContinuar() {
            return this.privacidad && this.terminos && this.condiciones;
        },
        tipoTarjeta() {
            if (this.cardNumber) {
                if (/^4[A-Za-z0-9]{15}$/.test(this.cardNumber.replace(/-/g, ''))) {
                    return 'fab fa-cc-visa';
                } else if (/^5[1-5][A-Za-z0-9]{14}$/.test(this.cardNumber.replace(/-/g, ''))) {
                    return 'fab fa-cc-mastercard';
                } else if (/^3[47][A-Za-z0-9]{13}$/.test(this.cardNumber.replace(/-/g, ''))) {
                    return 'fab fa-cc-amex';
                } else if (/^3[068][A-Za-z0-9]{12}$/.test(this.cardNumber.replace(/-/g, ''))) {
                    return 'fab fa-cc-diners-club';
                } else {
                    return 'fas fa-credit-card';
                }
            } else {
                return 'fas fa-credit-card';
            }
        },
        tarjetaFormatted() {
            if (this.cardNumber) {
                return this.cardNumber.slice(-4)
            } return '';
        }
    },
    methods: {
        aceptarCondiciones(continuar, privacidad, condiciones, comunicaciones) {
            if (continuar) {
                this.terminos = true;

                this.privacidad = privacidad;
                this.condiciones = condiciones;
                this.comunicaciones = comunicaciones;
            } else {
                this.terminos = false;
            }
        },
        continuarCompra() {
            this.loading = true;
            const data = {
                tid: this.tid,
                filters: {}
            }

            this.$store.dispatch(this.config.getVuexAlias('front.perfil.get-jet-id'), data).then(res => {
                this.jet_id = res.data.jet_id
            }).catch(e => { });

            data.plazos = false;

            this.$store.dispatch(this.config.getVuexAlias('front.perfil.info_pago'), data).then(res => {
                if (!res.data.error) {
                    this.cardNumber = res.data.pan;
                    this.cardMonth = res.data.mesCaducidad;
                    this.cardYear = res.data.anoCaducidad;
                    this.loading = false;
                    this.infoRecuperada = true;
                } else {
                    this.nuevaTarjeta = true;
                    this.error = true;
                    this.loading = false;
                }
            }).catch(() => {
                console.warn('Error al recuperar la información depago');
                this.nuevaTarjeta = true;
                this.error = true;
                this.loading = false;
            });

            this.compraConfirmada = true;
        },
        procesarPagoPlazosPerfil() {
            this.loading = true;
            const params = {
                filters: {},
                tid: this.tid,
                plazos: this.plazos,
                tipo_venta: this.tipo_venta
            }

            this.$store.dispatch(this.config.getVuexAlias('front.perfil.procesar-pago-plazos'), params).then(res => {
                if (res.data.message) {
                    this.$toast.success(res.data.message);
                } else if (res.data.error) {
                    this.$toast.error('Ha ocurrido un error');
                }
            }).catch(() => {
                this.error = true;
                this.loading = false;
            }).finally(() => {
                this.close();
                this.loading = false;
            });
        },
        close(pagoFinalizado = false) {
            this.terminos = false;
            this.privacidad = false;
            this.condiciones = false;
            this.comunicaciones = false;
            this.compraConfirmada = false;
            this.nuevaTarjeta = false;
            this.tarjetaGuardada = false;
            this.$emit('actualizar');

            if (pagoFinalizado) {
                this.$toast.success('Plazo/s pagado/s');
            }
        }
    },
    components: { ModalComponent, PagoPaycometComponent, FormTerminos }
}

</script>
